<script setup>
</script>
<template>
  <div>
    <h1>eShops</h1>
    <router-view />
  </div>

</template>